import api from 'api';

export default function retireWorker(workerId: string) {
  return api.put(`workers/${workerId}/retire`);
}
